import { type ReactElement } from 'react'

import { useTranslate } from '@orus.eu/pharaoh'
import { LoadingRegion } from '@orus.eu/pharaoh-next/components/ui/loading-region'
import { Skeleton } from '@orus.eu/pharaoh-next/components/ui/skeleton'
import { View } from '@orus.eu/pharaoh-next/components/ui/view'

/** Pending placeholder for the Payment methods screen — shares the View frame with the real content. */
export function PaymentMethodsPageSkeleton(): ReactElement {
  const translate = useTranslate()

  return (
    <LoadingRegion label={translate('loading_aria_label')}>
      <View.Root>
        <View.Header>
          <Skeleton variant="text" width={260} height={32} />
        </View.Header>
        <View.Body>
          <div className="flex flex-col gap-stack">
            <Skeleton variant="block" height={152} />
            <Skeleton variant="block" height={152} />
          </div>
        </View.Body>
      </View.Root>
    </LoadingRegion>
  )
}
